webpackJsonp([97420181259591],{

/***/ 813:
/***/ (function(module, exports) {

	module.exports = {"pathContext":{}}

/***/ })

});


// WEBPACK FOOTER //
// path---tutorials-examples-calculator-a0e39f21c11f6a62c5ab.js